import { Card, List } from 'antd';
import { type UserGroupSpecsFragment } from '../../../api/fragments/UserGroupSpecs';
import UserGroupDealerEmptyList from './UserGroupDealerEmptyList';
import UserGroupDealerListActions from './UserGroupDealerListActions';

export type UserGroupDealerListProps = { userGroup: UserGroupSpecsFragment };

const UserGroupDealerList = ({ userGroup }: UserGroupDealerListProps) => {
    if (userGroup.dealers.length === 0) {
        return <UserGroupDealerEmptyList userGroup={userGroup} />;
    }

    return (
        <Card>
            <List>
                {userGroup.dealers.map(dealer => (
                    <List.Item
                        key={dealer.id}
                        extra={<UserGroupDealerListActions dealer={dealer} userGroup={userGroup} />}
                    >
                        <List.Item.Meta title={dealer.displayName} />
                    </List.Item>
                ))}
            </List>
        </Card>
    );
};

export default UserGroupDealerList;
